import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class POSupplierAccessDashboardServiceBackofficeEp extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.GENERIC_PREFIX +
      "blanket-purchase-report/po/backoffice-ep";
    this.httpClient = http;
  }

  // tnt/dm/gen-doc/blanket-purchase-report/bpo/backoffice-ep

  generateReport(start_date: string, end_date: string, visa: ApiVisa): Observable<any> {

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const body = {
      BPO_TXN_DATE_FROM: start_date,
      BPO_TXN_DATE_TO: end_date,
    };
    // let header = this.getHttpHeader(visa);
    return this.httpClient.post<ApiResponseModel<any>>(this.apiUrl, body, this.getHttpHeader(visa));

    // return this.httpClient.get<any>(this.apiUrl,headers:header)
  }
}
